import React, { createContext, useState, useCallback, useEffect } from 'react';
import { base44 } from '@/api/base44Client';
import { useAuth } from '@/lib/AuthContext';

export const LoyaltyContext = createContext();

export function LoyaltyProvider({ children }) {
  // Auth state comes from AuthContext — the previous isAuthenticated()/me()
  // pair hit the server on every load and logged a 401 for signed-out visitors.
  const { user } = useAuth();
  const [cachedData, setCachedData] = useState({
    loyaltyData: null,
    history: [],
    goldStatus: null,
    isInitialized: false
  });

  const setLoyaltyCache = useCallback((data) => {
    setCachedData(prev => ({
      ...prev,
      ...data,
      isInitialized: true
    }));
  }, []);

  const clearLoyaltyCache = useCallback(() => {
    setCachedData({
      loyaltyData: null,
      history: [],
      goldStatus: null,
      isInitialized: false
    });
  }, []);

  // Subscribe to real-time loyalty account updates
  useEffect(() => {
    if (!user) return;

    let unsubscribe;
    try {
      // Subscribe to SquareLoyaltyAccount updates in real-time
      unsubscribe = base44.entities.SquareLoyaltyAccount.subscribe((event) => {
        if (event.type === 'update' && cachedData.loyaltyData?.id === event.id) {
          setLoyaltyCache({ loyaltyData: event.data });
          // Also update localStorage for persistence
          localStorage.setItem('loyaltyData', JSON.stringify(event.data));
        }
      });
    } catch (error) {
      console.error('[LoyaltyContext] Subscription setup failed:', error);
    }

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [user, cachedData.loyaltyData?.id, setLoyaltyCache]);

  return (
    <LoyaltyContext.Provider value={{ ...cachedData, setLoyaltyCache, clearLoyaltyCache }}>
      {children}
    </LoyaltyContext.Provider>
  );
}